import { useDispatch, useSelector } from 'react-redux';
import { startCase } from 'lodash';
import { useEffect } from 'react';
import { useMetalStreamData } from './useMetalStreamData';
import { metalStreamDataHelper } from '../util/helpers/metalStreamDataHelper';
import {
  selectMetalStreamGoldProducts,
  selectMetalStreamSilverProducts,
} from '../store/selectors/metalStreamSelectors';
import { parseEnumType } from '../util/helpers/enumMappers';
import { productLocationTypes } from '../util/enum/api/productTypes';
import { buildProductProps } from '../util/helpers/reviewHelper';

import { selectSettings } from '../store/selectors/settingsSelectors';
import config from '../config';
import {
  getMetalStreamGoldProducts,
  getMetalStreamSilverProducts,
} from '../store/actions/metalStream/metalStreamActions';
import useApplicationUid from './useApplicationUid';

const useMetalStreamSelectedProducts = () => {
  const dispatch = useDispatch();
  const { ApplicationUid } = useApplicationUid();
  const { RootUrl } = useSelector(selectSettings);

  const { MetalStreamData } = useMetalStreamData();
  const metalStreamGoldProducts = useSelector(selectMetalStreamGoldProducts);
  const metalStreamSilverProducts = useSelector(
    selectMetalStreamSilverProducts,
  );

  const goldPercentage = metalStreamDataHelper(
    MetalStreamData,
    'GoldPercentage',
  );
  const silverPercentage = metalStreamDataHelper(
    MetalStreamData,
    'SilverPercentage',
  );
  const goldProductCode = metalStreamDataHelper(
    MetalStreamData,
    'SymbolCodeGold',
  );
  const silverProductCode = metalStreamDataHelper(
    MetalStreamData,
    'SymbolCodeSilver',
  );
  const Amount = metalStreamDataHelper(MetalStreamData, 'Amount');

  const resultGold = metalStreamGoldProducts.find((product) =>
    product.Locations.some(
      (location) => location.SymbolCode === goldProductCode,
    ),
  );
  const resultSilver = metalStreamSilverProducts.find((product) =>
    product.Locations.some(
      (location) => location.SymbolCode === silverProductCode,
    ),
  );

  const silverMetalReviewProps = silverPercentage
    ? buildProductProps(
        {
          ...resultSilver,
          Location: startCase(
            parseEnumType(
              productLocationTypes,
              resultSilver?.Locations?.find(
                (location) => location.SymbolCode === silverProductCode,
              ).LocationType,
            ),
          ),
          Amount: ((silverPercentage * Amount) / 100).toFixed(2),
          SymbolCode: silverProductCode,
        },
        RootUrl,
        config.algoliaSearch.imageCode,
        true,
      )
    : null;

  const goldMetalReviewProps = goldPercentage
    ? buildProductProps(
        {
          ...resultGold,
          Location: startCase(
            parseEnumType(
              productLocationTypes,
              resultGold?.Locations?.find(
                (location) => location.SymbolCode === goldProductCode,
              ).LocationType,
            ),
          ),
          Amount: ((goldPercentage * Amount) / 100).toFixed(2),
          SymbolCode: goldProductCode,
        },
        RootUrl,
        config.algoliaSearch.imageCode,
        true,
      )
    : null;

  useEffect(() => {
    dispatch(
      getMetalStreamGoldProducts({
        ApplicationUid,
      }),
    );
    dispatch(
      getMetalStreamSilverProducts({
        ApplicationUid,
      }),
    );
  }, [ApplicationUid, dispatch]);

  return {
    silverMetalReviewProps,
    goldMetalReviewProps,
  };
};

useMetalStreamSelectedProducts.propTypes = {};

export default useMetalStreamSelectedProducts;
